import type { Language } from '@application/types';
import credit from './credit.png';
import progenus from './progenus.webp';
import partnership1 from './partnership1.webp';
import partnership2 from './partnership2.webp';
import partrnership1QRCodeFR from './partnership1QRCodeFR.png';
import partrnership1QRCodeNL from './partnership1QRCodeNL.png';
import partrnership1QRCodeDE from './partnership1QRCodeDE.png';

import partrnership2QRCodeFR from './partnership2QRCodeFR.png';
import partrnership2QRCodeNL from './partnership2QRCodeNL.png';
import partrnership2QRCodeDE from './partnership2QRCodeDE.png';

const IMAGES = { progenus, credit, partnership1, partnership2 };
const QRCODES: Record<string, Record<Language, string>> = {
  partnership1: {
    fr: partrnership1QRCodeFR,
    nl: partrnership1QRCodeNL,
    de: partrnership1QRCodeDE,
    en: partrnership1QRCodeFR,
  },
  partnership2: {
    fr: partrnership2QRCodeFR,
    nl: partrnership2QRCodeNL,
    de: partrnership2QRCodeDE,
    en: partrnership2QRCodeFR,
  },
};

export { IMAGES, QRCODES };
